<template>
  <v-container
    :class="containerClass"
    class="my-8"
  >
    <grid-layout
      v-if="locale && webpage"
      v-model:layout="webpage.layout[size]"
      :auto-size="true"
      :col-num="36"
      :is-draggable="false"
      :is-resizable="false"
      :row-height="8"
    >
      <grid-item
        v-for="item in sortedLayoutItems"
        :key="item.i"
        :h="item.h"
        :i="item.i"
        :w="item.w"
        :x="item.x"
        :y="item.y"
      >
        <PageElement
          v-model="elements[item.i]"
          :item="elements[item.i]"
          :lang="$i18n.locale"
          mode="view"
        />
      </grid-item>
    </grid-layout>
  </v-container>
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
import { GridLayout, GridItem } from 'grid-layout-plus';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import PageElement from '@/shared/components/PageElement.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';

const { api: Api } = useApi();
const display = useDisplay();
const eventBus = useEventBus();
const { locale } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

const elements = ref({});
const webpage = ref(null);

const containerClass = computed(() => {
  if (size.value === 'lg') return 'mxw-1200';
  if (size.value === 'md') return 'mxw-800';

  return 'mxw-440';
});

const size = computed(() => {
  if (display.lgAndUp.value) return 'lg';
  if (display.mdAndUp.value) return 'md';

  return 'sm';
});

// Sort needed for tab order to match visual order; this does top/bottom/left/right hierarchy.
const sortedLayoutItems = computed(() => {
  const layout = webpage.value?.layout?.[size.value];
  if (!layout?.length) return [];

  return [...layout].sort((left, right) => {
    if (left.y !== right.y) return left.y - right.y;
    if (left.x !== right.x) return left.x - right.x;

    // same grid cell has no order rule
    return 0;
  });
});

function load() {
  if (route?.query?.chime) eventBus.chime(route.query.chime);
  if (!store.state.siteWebpageId) {
    if (store.state.config.has_external_welcome_html) {
      window.location.href = '/';
      return;
    }
    return router?.replace({ name: 'Welcome' });
  }

  Api.publicApi.organization.webpage.get(store.state.siteWebpageId, (resp) => {
    webpage.value = resp.data;
    if (webpage.value.redirect_url) {
      window.location.href = webpage.value.redirect_url;
    }

    webpage.value.elements.forEach((element) => {
      elements.value[element.i] = element;
    });
  });
}

onMounted(load);
</script>

<style>
.v-btn__content {
  white-space: pre-wrap;
}
</style>
